import vueCropper from "vue-cropper"
import Vue from "vue"
Vue.use(vueCropper)
// Vue.component('vue-cropper', vueCropper)
